import { ComponentProps } from 'react'

import { FormControl } from './form'
import { StarRating } from '../star-rating'

const FormRating = (props: ComponentProps<typeof StarRating>) => {
  return (
    <FormControl>
      <StarRating {...props} />
    </FormControl>
  )
}

export { FormRating }
